import { type Translations, translations } from "./translations";
import { useI18n } from "./use-i18n.store";

export function useTranslate(): Translations {
	const lang = useI18n((s) => s.lang);
	return translations[lang];
}
